import { render, staticRenderFns } from "./ObjectEmbed.vue?vue&type=template&id=d40adc10&"
import script from "./ObjectEmbed.vue?vue&type=script&lang=js&"
export * from "./ObjectEmbed.vue?vue&type=script&lang=js&"
import style0 from "./ObjectEmbed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports